import React from "react";
import Box from "@mui/material/Box";
import DashboardLeaveStatusDonut from "../web/widgets/DashboardLeaveStatusDonut";

export default function MobileDashboardLeaveStatusDonut({ leaves }) {
    return (
        <Box sx={{
            "& .MuiCard-root": {
                borderRadius: "16px",
                boxShadow: "0 8px 24px rgba(15, 23, 42, 0.10)",
            }
        }}>
            <DashboardLeaveStatusDonut leaves={leaves} />
        </Box>
    );
}
